import script from "./personNameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./personNameInput.vue?vue&type=script&setup=true&lang=ts"

import "./personNameInput.vue?vue&type=style&index=0&id=456ecaae&scoped=true&lang=css"
import "./personNameInput.vue?vue&type=style&index=1&id=456ecaae&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-456ecaae"]])

export default __exports__